"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/MembersTab/components/Modals/RejectMember/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _noticeBar = require('web/services/context/noticeBar');
var _Modal = require('web/components/Modal');










const RejectMemberModal = ({
  onClose, entity, onProceed, orgName,
}) => {
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)

  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onSubmit = () => {
    setIsLoading(true)
    onProceed()
      .then(() => showSuccessBar("User was not added to your organization."))
      .then(onClose)
      .catch(() => {
        showWarningBar("Error processing the rejection.")
        setIsLoading(false)
      })
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('span', { className: "settings--org-members--remove-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, "You are about to reject "
             , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  entity.name ), " from joining "   , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  orgName ), "."
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnTheme: "danger",
        primaryBtnLabel: "Reject",
        isPrimaryLoading: isLoading,
        onPrimaryBtnClick: onSubmit,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      )
    )
  )
}

exports. default = RejectMemberModal
